import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({
    providedIn: 'root'
})
export class CuDepartmentService extends ApiService {

    select(params: any = {}) {
        return super.get(`/cu-departments/select`, params);
    }
}
